<template>
  <div>
    <v-form v-model="valid" ref="form">
      <v-text-field
        v-model="value.status"
        :label="$t('entities.environment.jobStageStatus.props.status')"
        :rules="$isRequiredRule"
      ></v-text-field>
      <v-text-field
        v-model="value.seq"
        :label="$t('entities.environment.jobStageStatus.props.seq')"
        :rules="$isRequiredRule"
      ></v-text-field>
      <v-text-field
        v-model="value.description"
        :label="$t('entities.environment.jobStageStatus.props.description')"
        :rules="$isRequiredRule"
      ></v-text-field>
      <color-dialog
        v-model="value.color"
        :label="$t('entities.environment.jobStageStatus.props.color')"
      ></color-dialog>
      <v-select
        v-model="value.type"
        :items="types"
        item-text="value"
        item-value="key"
        :label="$t('entities.environment.jobStageStatus.props.type')"
        :rules="$isRequiredRule"
      ></v-select>
      <v-select
        v-model="value.statusNext"
        :items="status"
        attach
        chips
        :label="$t('entities.environment.jobStageStatus.props.statusNext')"
        multiple
      ></v-select>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {
        return {
          seq: 0,
          status: "",
          description: "",
          color: "",
          statusNext: [],
          type: ""
        };
      }
    },
    status: {
      type: Array
    }
  },
  watch: {
    value() {
      this.$refs.form.resetValidation();
      this.color.hex = this.value.color;
    },
    color() {
      this.value.color = this.color.hex;
    }
  },
  data() {
    return {
      valid: true,
      openColor: false,
      color: {},
      types: [
        { key: 0, value: "Opened" },
        { key: 1, value: "Finished" }
      ]
    };
  },
  methods: {
    isValid() {
      return this.$refs.form.validate();
    },
    clickColor() {
      this.openColor = !this.openColor;
    }
  }
};
</script>